//
import PaymentConditionModel from "@/models/Purchase/PchPaymentCondition"
import ProviderModel from "@/models/Purchase/PchProvider"

//
export default {

  /**
   * 
   */
  toList() {
    return [
        {
            name: "invoice_number",
            props: {
                label: "N° de factura",
            },
            type: "text-field"
        },
        {
            name: "pch_provider_id",
            props: {
                itemText: "alias_name",
                itemValue: "id",
                noObject: true,
                label: "Proveedor",
                model: ProviderModel,
            },
            type: "autocomplete-model"
        },
        {
            name: "pch_payment_condition_id",
            props: {
                itemText: "type",
                itemValue: "id",
                label: "Condición de pago",
                model: PaymentConditionModel,
                noObject: true,
                paramSearch: "type",
            },
            type: "autocomplete-model"
        },
        {
            name: "is_exent",
            props: {
                chips: true,
                clearable: true,
                hideDetails: true,
                items: [
                    { text: "No", value: "false" },
                    { text: "Si", value: "true" },
                ],
                label: "Exenta",
            },
            type: "select"
        },
        {
            name: "created_from",
            props: {
                hideDetails: true,
                label: "Creada desde",
            },
            type: "date-field"
        },
    ]
  }
}
